import * as React from 'react';
import Box from '@mui/material/Box';
import { Grid } from '@mui/material';
import { loadCSS } from 'fg-loadcss';
import ReservationsChart from './components/ReservationsChart';
import ReservationsTable from './components/ReservationsTable';
import RevenueSection from './components/RevenueSection';
import { useNavigate } from 'react-router-dom';
import { Container } from '@mui/system';
import { Booking } from '../types/booking';

export default function Dashboard() {
  const role = localStorage.getItem('role');
  const navigate = useNavigate();
  const [selectedDate, setSelectedDate] = React.useState<Date | null>(null);
  const [selectedBookings, setSelectedBookings] = React.useState<Booking[]>([]);

  React.useEffect(() => {
    if (!role) {
      navigate('/user-login', {
        state: 'You do not have permission',
      });
    }
  }, []);

  React.useEffect(() => {
    const node = loadCSS(
      'https://use.fontawesome.com/releases/v5.15.3/css/all.css',
      document.querySelector('#font-awesome-css') || document.head.firstChild
    );
    return () => {
      node?.parentNode?.removeChild(node);
    };
  }, []);

  const handleBarClick = (date: Date, bookings: Booking[]) => {
    setSelectedDate(date);
    setSelectedBookings(bookings);
  };

  return (
    <Container
      className="dashboard mx:auto "
      sx={{
        marginTop: '115px !important',
        width: '100%',
        padding: '0px 15px !important',
      }}
    >
      <Box>
        <Grid container spacing={3}>
          {/* Reservations Chart */}
          <Grid item xs={12}>
            <ReservationsChart onBarClick={handleBarClick} />
          </Grid>

          {/* Reservations Table */}
          <Grid item xs={12}>
            <ReservationsTable
              selectedDate={selectedDate}
              bookings={selectedBookings}
            />
          </Grid>

          {/* Revenue Section */}
          <Grid item xs={12} sx={{ marginTop: 3 }}>
            <RevenueSection />
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}
